// -----------------------------------------------------------------------------
// Persists the URL a user was trying to reach when they got bounced to login, so
// we can return them there afterwards instead of dropping them on /home.
//
// It lives in sessionStorage rather than the Pinia store because an expired
// session triggers a hard `window.location` redirect to /login (see api/base.ts),
// which wipes all in-memory state. sessionStorage survives that reload.
// -----------------------------------------------------------------------------

const KEY = "redirectAfterLogin";

export const setRedirectAfterLogin = (fullPath: string): void => {
	sessionStorage.setItem(KEY, fullPath);
};

/** Returns the stored path (if any) and clears it, so it is only used once. */
export const takeRedirectAfterLogin = (): string | null => {
	const fullPath = sessionStorage.getItem(KEY);
	sessionStorage.removeItem(KEY);
	return fullPath;
};

export const clearRedirectAfterLogin = (): void => {
	sessionStorage.removeItem(KEY);
};